class SearchModal extends HTMLElement {
  constructor() {
    super();

    if (this.isPredictiveSearchDisabled()) return;

    this.modal = this.querySelector('.search-modal');
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.input = this.querySelector('.search__input');
    this.header = document.querySelector('.header');
    this.__userInitiatedSearch = false;

    if (!this.modal || !this.detailsContainer || !this.summaryToggle || !this.input) return;

    this.searchField = this.summaryToggle.querySelector('.search-field__text');
    this.overlay = this.detailsContainer.querySelector('.search-modal__overlay');

    this.buttonClose = !this.modal.className.includes('drawer')
      ? this.querySelector('.button-close--search')
      : this.querySelector('.button-close--search-drawer');

    document.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.modal.className.includes('open')) {
        this.close();
      }
    });

    if (this.searchField) {
      const closeBtn = this.summaryToggle.querySelector('.button-close');

      this.searchField.addEventListener('pointerdown', () => {
        this.__userInitiatedSearch = true;
      }, { passive: true });

      this.searchField.addEventListener('touchstart', () => {
        this.__userInitiatedSearch = true;
      }, { passive: true });

      this.searchField.addEventListener('focus', (event) => {
        if (!this.__userInitiatedSearch) return;
        this.__userInitiatedSearch = false;
        this.open(event, true);
      });

      if (closeBtn) {
        closeBtn.addEventListener('focusout', this.close.bind(this));
      }
    } else {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    }

    window.addEventListener('pageshow', () => {
      this.__userInitiatedSearch = false;
      this.close();
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', (event) => {
        this.reset(event);
        this.close();
      });
    }

    const searchButton = document.querySelector('.search__button');
    if (searchButton) {
      searchButton.addEventListener('click', this.reset.bind(this));
    }

    if (this.buttonClose) {
      this.buttonClose.addEventListener('click', (event) => {
        this.reset(event);
        this.close();
      });
    }

    if (this.header) {
      this.header.addEventListener('click', (event) => {
        if (this.modal.closest('.open') && !event.target.closest('.search')) {
          this.reset(event);
          this.close();
        }
      });
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isPredictiveSearchDisabled() {
    const shopifyFeatures = document.getElementById('shopify-features');
    const features = shopifyFeatures ? JSON.parse(shopifyFeatures.textContent) : {};
    const isPredictiveSearchSupported = features.predictiveSearch === true;

    const supportedLanguages = [
      'af', 'sq', 'hy', 'bs', 'bg', 'ca', 'hr', 'cs', 'da', 'nl', 'en',
      'et', 'fo', 'fi', 'fr', 'gd', 'de', 'el', 'hu', 'is', 'id', 'it',
      'la', 'lv', 'lt', 'mk', 'mo', 'no', 'nb', 'nn', 'pl', 'pt-BR',
      'pt-PT', 'ro', 'ru', 'sr', 'sh', 'sk', 'sl', 'es', 'sv', 'tr',
      'uk', 'vi', 'cy'
    ];

    const currentLanguage = document.documentElement.lang;

    return !isPredictiveSearchSupported || !supportedLanguages.includes(currentLanguage);
  }

  onSummaryClick(event) {
    event.preventDefault();

    const details = event.target.closest('details');
    if (!details) return;

    details.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (
      event.target.classList.contains('search-modal__overlay') ||
      event.target.closest('.button-close--search') ||
      event.target.closest('.button-close--search-drawer')
    ) {
      this.close();
    }
  }

  open(event, listerner) {
    if (!this.modal || !this.detailsContainer || !this.summaryToggle || !this.input) return;

    const searchText = this.summaryToggle.querySelector('.search-field__text');

    if (searchText && searchText.closest('.focused') && listerner == false) return;

    this.focusElement = event && event.target ? event.target : this.summaryToggle;

    if (this.modal.className.includes('open') || document.querySelector('body > .search-modal.open')) return;

    if (this.searchField && !this.modal.className.includes('drawer')) {
      const scrollY = window.scrollY || window.pageYOffset;
      document.body.dataset.scrollY = scrollY;
      document.body.style.top = `-${scrollY}px`;
      document.body.classList.add('disable-scroll');
    }

    document.body.appendChild(this.modal);

    if (this.overlay && !document.querySelector('body > .search-modal__overlay')) {
      this.overlay.classList.remove('open');
      document.body.appendChild(this.overlay);
    }

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);

    if (this.overlay) {
      if (this.modal.className.includes('drawer')) {
        setTimeout(() => this.overlay.classList.add('open'), 300);
      } else {
        this.overlay.classList.add('open');
      }
    }

    document.body.addEventListener('click', this.onBodyClickEvent);

    if (this.modal.className.includes('drawer')) {
      requestAnimationFrame(() => {
        if (this.overlay) this.overlay.classList.add('open');

        document.body.classList.add('hidden');
        this.modal.classList.add('open');

        const headerEl = this.closest('.header');
        if (headerEl) {
          const height = Math.floor(headerEl.getBoundingClientRect().bottom);
          document.documentElement.setAttribute(
            'style',
            `--header-offset-height: ${height}px; --header-height: ${height}px;`
          );
        }

        document.dispatchEvent(new CustomEvent('searchmodal:open'));

        if (this.searchField) {
          this.input.setAttribute('value', this.searchField.value);
          this.input.value = this.searchField.value;

          if (typeof trapFocus === 'function') {
            trapFocus(this.searchField, this.input);
          }

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.input.focus();
            });
          });
        } else {
          if (typeof trapFocus === 'function') {
            trapFocus(this.detailsContainer, this.input);
          }
        }
      });
    } else {
      document.body.classList.add('search-modal--open');
      document.body.classList.add('hidden');
      this.modal.classList.add('open');

      const headerEl = this.closest('.header');
      if (headerEl) {
        const height = Math.floor(headerEl.getBoundingClientRect().bottom);
        document.documentElement.setAttribute(
          'style',
          `--header-offset-height: ${height}px; --header-height: ${height}px;`
        );
      }

      document.dispatchEvent(new CustomEvent('searchmodal:open'));
    }

    if (this.searchField) {
      this.input.setAttribute('value', this.searchField.value);
      this.input.value = this.searchField.value;

      if (typeof trapFocus === 'function') {
        trapFocus(this.searchField, this.input);
      }

      requestAnimationFrame(() => {
        this.input.focus();
      });
    } else {
      if (typeof trapFocus === 'function') {
        trapFocus(this.detailsContainer, this.input);
      }
    }
  }

  close() {
    if (!this.modal || !this.detailsContainer || !this.summaryToggle) return;

    if (this.searchField && document.body.classList.contains('disable-scroll')) {
      document.body.classList.add('after-focusout');
      document.documentElement.style.scrollBehavior = 'auto';

      const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);

      document.body.classList.remove('disable-scroll');
      document.body.style.top = '';

      window.scrollTo({ top: scrollY, left: 0, behavior: 'auto' });
    }

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.focusElement);
    }

    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);

    if (!this.modal.className.includes('drawer')) {
      document.body.classList.remove('search-modal--open');
    }

    document.dispatchEvent(new CustomEvent('searchmodal:close'));
    document.body.classList.remove('hidden');

    const searchButtonText = document.querySelector('.search__button-text');
    if (searchButtonText) {
      searchButtonText.classList.add('visually-hidden');
    }

    this.modal.classList.remove('open');

    document.dispatchEvent(new CustomEvent('body:visible'));

    if (this.modal.parentNode === document.body) {
      this.modal.remove();
    }

    const overlayOpen = document.querySelector('.search-modal__overlay.open');
    if (overlayOpen && overlayOpen.parentNode === document.body) {
      overlayOpen.remove();
    }

    const searchText = this.summaryToggle.querySelector('.search-field__text');
    if (searchText) {
      const form = searchText.closest('form');
      const btn = form ? form.querySelector('.search__button') : null;

      if (btn) {
        btn.setAttribute('tabindex', '-1');
      }
    }

    setTimeout(() => {
      document.documentElement.style.scrollBehavior = 'smooth';
    }, 10);

    setTimeout(() => {
      document.body.classList.remove('after-focusout');
    }, 200);
  }

  reset(event) {
    if (event) event.preventDefault();

    const input = this.querySelector('input[type="search"]');

    if (input && input.hasAttribute('value')) {
      input.value = '';
      input.removeAttribute('value');
    }
  }
}

if (!customElements.get('search-modal')) {
  customElements.define('search-modal', SearchModal);
}